var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgViewVariableGrid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6,
    fill: "#3D8EDA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    width: 6,
    height: 6,
    fill: "#3D8EDA"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    width: 6,
    height: 6,
    fill: "#3D8EDA"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    y: 8,
    width: 6,
    height: 6,
    fill: "#3D8EDA"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    y: 16,
    width: 6,
    height: 6,
    fill: "#3D8EDA"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 6,
    height: 6,
    fill: "#3D8EDA"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 16,
    width: 6,
    height: 6,
    fill: "#3D8EDA"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 8,
    width: 6,
    height: 6,
    fill: "#3D8EDA"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 16,
    width: 6,
    height: 6,
    fill: "#3D8EDA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewVariableGrid);
export default __webpack_public_path__ + "static/media/view-variable-grid.604bde9af6e706f80f4ced291d202ca2.svg";
export { ForwardRef as ReactComponent };